import React, { useEffect, useState } from "react";
import './slideshow.scss';
export const SlideShow = ({ images }) => {
    var _a;
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        if (!images)
            return;
        if (images.length <= 1)
            return;
        const interval = setInterval(() => {
            setCurrentIndex((currentIndex + 1) % images.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [currentIndex, images.length]);
    if ((images === null || images === void 0 ? void 0 : images.length) <= 0)
        return null;
    return React.createElement("div", { dir: "rtl", className: "elementor-background-slideshow" },
        React.createElement("div", { key: 'slide-' + currentIndex, className: `elementor-background-slideshow__slide__image${(images === null || images === void 0 ? void 0 : images.length) > 1 ? ' --animated' : ''}`, style: { backgroundImage: ` url(${(_a = images[currentIndex]) === null || _a === void 0 ? void 0 : _a.url})` } }));
};
